export default __webpack_public_path__ + "static/media/Ritam's Resume.717c63d7.pdf";